export type CollapsibleMetricTypes = {
  types: string[];
};

/**
 * Returns a single type for a metric, to help panel generation pick a line plot
 * or a media panel, and to help media pickers pick a card type.
 *
 * Takes the first entry, so a key with more than one type gets whichever sorts
 * first. The backend sorts `types` and documents the order as meaningless, so
 * that choice is arbitrary.
 *
 * TODO: once the backend serves `MetricInfo.latestType` this becomes two steps
 * — use `latestType` when it names a type we render, otherwise the first type
 * in `types` we render, media before charts. The first is for media, which has
 * to choose one card type per panel; the second is for charts, where having
 * logged a number or histogram at all is enough.
 *
 * Null when there is nothing to go on, so the key generates no panel.
 */
export function collapseMetricTypes(
  metric: CollapsibleMetricTypes
): string | null {
  return metric.types[0] ?? null;
}
